/* tslint:disable */
/* eslint-disable */

/**
 * Phone types Enum for Messaging (manually registered in swagger)
 */
export enum WorkPhoneTypeNamesEnum {
  Privat = 'Privat',
  Mobil = 'Mobil',
  Geschaft = 'Gesch\xE4ft',
  Unbekannt = 'Unbekannt'
}
